<mat-card>
  <mat-card-title>
    <!--Main header-->
    {{'Undercarriage Worn Limit Management' | translate | async}}
  </mat-card-title>

  <mat-card-content>
    <mat-card>
      <mat-card-content class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">

        <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>{{'Select Make' | translate | async}}</mat-placeholder>
          <mat-select id="select-make" [(ngModel)]="selectedMake" ngDefaultControl (selectionChange)="changeMake()">
            <mat-option [value]="mdl.Id" *ngFor="let mdl of MakeList">
              {{mdl.Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <!-- <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>Select Model</mat-placeholder>
          <mat-select id="select-model" [(ngModel)]="selectedModel" ngDefaultControl (change)="changeModel()">
            <mat-option [value]="mdl.Id" *ngFor="let mdl of ModelList">
              {{mdl.Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->


        <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>{{'Select Component Type' | translate | async}}</mat-placeholder>
          <mat-select id="select-Comp" [(ngModel)]="selectedCompType" ngDefaultControl (selectionChange)="changeCompType()">
            <mat-option [value]="mdl.Id" *ngFor="let mdl of CompTypeList">
              {{mdl.Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>{{'Select Component' | translate | async}}</mat-placeholder>
          <mat-select id="select-Component" [(ngModel)]="selectedComponent" (selectionChange)="changeCompart()" ngDefaultControl>
            <mat-option [value]="mdl.Id" *ngFor="let mdl of ComponentList">
              {{mdl.Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>{{'Select Part #' | translate | async}}</mat-placeholder>
          <mat-select id="select-Part" [(ngModel)]="selectedPart" ngDefaultControl (selectionChange)="changePart()">
            <mat-option [value]="mdl.Id" *ngFor="let mdl of PartList">
              {{mdl.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 15%;" class="header-form-full-width">
          <mat-placeholder>{{"Select Tool Used" | translate | async}}</mat-placeholder>
          <mat-select id="select-tool" [(ngModel)]="selectedTool" ngDefaultControl>
            <mat-option [value]="mdl.Id" *ngFor="let mdl of ToolList">
              {{mdl.Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </mat-card-content>
      <mat-card-actions class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">
        <div style="display: flex;flex-direction: row;min-width: 30px;" class="header-form-full-width">
        </div>
        <div class="header-form-full-width" style="display: flex;flex-direction: row;">
          <button mat-raised-button color="warn" (click)="onClickSearch()" style="margin-right: 20px;"> {{'Search' | translate | async}} </button>
          <button mat-raised-button color="warn" (click)="onClickReset()"> {{'Reset' | translate | async}} </button>
        </div>
      </mat-card-actions>
    </mat-card>
    <mat-card>
      <!--CAT -- Or Inflection-->

      <div *ngIf="selectedMethod == 2" style="    width: 100%; overflow-x: auto;">
        <div style="display: flex; justify-content: space-around; flex-direction: row;">
          <div style="padding: 10px;">
            <mat-label>{{'General Information' | translate | async}}</mat-label>
          </div>
          <div style="padding: 10px;">
            <mat-label>{{'High Impact' | translate | async}}</mat-label>
          </div>
          <div style="padding: 10px;">
            <mat-label>{{'Low Impact' | translate | async}}</mat-label>
          </div>
        </div>
        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>{{'Make' | translate | async}}</th>
              <th>{{'Comp. Type' | translate | async}}</th>
              <th>{{'Component' | translate | async}}</th>
              <th>{{'Part #' | translate | async}}</th>
              <th>{{'Method' | translate | async}}</th>
              <th>{{'Tool Used' | translate | async}}</th>
              <th>{{'Slope' | translate | async}}</th>
              <th>{{'Adjust to Base' | translate | async}}</th>
              <th>{{'Inflect Pt.' | translate | async}}</th>
              <th>{{'Slope1' | translate | async}}</th>
              <th>{{'Y Int.1' | translate | async}}</th>
              <th>{{'Slope2' | translate | async}}</th>
              <th>{{'Y Int.2' | translate | async}}</th>
              <th>{{'Inflect Pt.' | translate | async}}</th>
              <th>{{'Slope1' | translate | async}}</th>
              <th>{{'Y Int.1' | translate | async}}</th>
              <th>{{'Slope2' | translate | async}}</th>
              <th>{{'Y Int.2' | translate | async}}</th>
              <th>{{'Starting Dim' | translate | async}}</th>
              <th>{{'100% Worn' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="InflectionData!=null">
              <tr *ngFor="let item of InflectionData" (click)="InflectionRowClick(item)" style="cursor: pointer;">
                <td class="component-cell">{{MakeName}}</td>
                <td class="component-cell">{{ComprtType}}</td>
                <td class="component-cell">{{Component}}</td>
                <td class="component-cell">{{PartNo}}</td>
                <td class="component-cell">{{MethodName}}</td>
                <td class="component-cell">{{item.ToolName}}</td>
                <td class="component-cell">{{item.Slope}}</td>
                <td class="component-cell">{{item.adjust_base}}</td>
                <td class="component-cell">{{item.hi_InflectionPoint}}</td>
                <td class="component-cell">{{item.hi_Slope_1}}</td>
                <td class="component-cell">{{item.hi_Intercept_1}}</td>
                <td class="component-cell">{{item.hi_Slope_2}}</td>
                <td class="component-cell">{{item.hi_Intercept_2}}</td>
                <td class="component-cell">{{item.mi_InflectionPoint}}</td>
                <td class="component-cell">{{item.mi_Slope_1}}</td>
                <td class="component-cell">{{item.mi_Intercept_1}}</td>
                <td class="component-cell">{{item.mi_Slope_2}}</td>
                <td class="component-cell">{{item.mi_Intercept_2}}</td>
                <td class="component-cell">{{item.Starting_Dim}}</td>
                <td class="component-cell">{{item.Worn_100}}</td>
              </tr>
            </ng-container>
            <tr *ngIf="InflectionData==null">
              <td class="component-cell">{{'No records to display.' | translate | async}}</td>
            </tr>

          </tbody>
        </table>
      </div>


      <!--STEPPED-->
      <div *ngIf="selectedMethod == 1" style="    width: 100%; overflow-x: auto;">
        <div style="display: flex; justify-content: space-around; flex-direction: row;">
          <div style="padding: 10px;">
            <mat-label>{{'General Information' | translate | async}}</mat-label>
          </div>
          <div style="padding: 10px;">
            <mat-label>{{'High Impact' | translate | async}}</mat-label>
          </div>
          <div style="padding: 10px;">
            <mat-label>{{'Low Impact' | translate | async}}</mat-label>
          </div>
        </div>

        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>{{'Make' | translate | async}}</th>
              <th>{{'Comp. Type' | translate | async}}</th>
              <th>{{'Component' | translate | async}}</th>
              <th>{{'Part #' | translate | async}}</th>
              <th>{{'Method' | translate | async}}</th>
              <th>{{'Tool Used' | translate | async}}</th>
              <th>{{'New High' | translate | async}}</th>
              <th>10%</th>
              <th>20%</th>
              <th>30%</th>
              <th>40%</th>
              <th>50%</th>
              <th>60%</th>
              <th>70%</th>
              <th>80%</th>
              <th>90%</th>
              <th>100%</th>
              <th>110%</th>
              <th>120%</th>
              <th>{{'New Low' | translate | async}}</th>
              <th>10%</th>
              <th>20%</th>
              <th>30%</th>
              <th>40%</th>
              <th>50%</th>
              <th>60%</th>
              <th>70%</th>
              <th>80%</th>
              <th>90%</th>
              <th>100%</th>
              <th>110%</th>
              <th>120%</th>
              <th>{{'Starting Dim' | translate | async}}</th>
              <th>100% {{"Worn" | translate | async}}</th>

            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="SteppedData!=null">
              <tr *ngFor="let item of SteppedData" (click)="SteppedRowClick(item)" style="cursor: pointer;">
                <td class="component-cell">{{MakeName}}</td>
                <td class="component-cell">{{ComprtType}}</td>
                <td class="component-cell">{{Component}}</td>
                <td class="component-cell">{{PartNo}}</td>
                <td class="component-cell">{{MethodName}}</td>
                <td class="component-cell">{{item.ToolName}}</td>
                <td class="component-cell">{{item.startDepeth_New}}</td>
                <td class="component-cell">{{item.wearDepth_10}}</td>
                <td class="component-cell">{{item.wearDepth_20}}</td>
                <td class="component-cell">{{item.wearDepth_30}}</td>
                <td class="component-cell">{{item.wearDepth_40}}</td>
                <td class="component-cell">{{item.wearDepth_50}}</td>
                <td class="component-cell">{{item.wearDepth_60}}</td>
                <td class="component-cell">{{item.wearDepth_70}}</td>
                <td class="component-cell">{{item.wearDepth_80}}</td>
                <td class="component-cell">{{item.wearDepth_90}}</td>
                <td class="component-cell">{{item.wearDepth_100}}</td>
                <td class="component-cell">{{item.wearDepth_110}}</td>
                <td class="component-cell">{{item.wearDepth_120}}</td>
                <td class="component-cell">{{item.startDepeth_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_10_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_20_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_30_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_40_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_50_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_60_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_70_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_80_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_90_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_100_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_110_Mi}}</td>
                <td class="component-cell">{{item.wearDepth_120_Mi}}</td>
                <td class="component-cell">{{item.Starting_Dim}}</td>
                <td class="component-cell">{{item.Worn_100}}</td>
              </tr>
            </ng-container>
            <tr *ngIf="SteppedData==null">
              <td class="component-cell">{{'No records to display.' | translate | async}}</td>
            </tr>

          </tbody>
        </table>
      </div>


      <!--komatsu -- Or Ploynomial-->
      <div *ngIf="selectedMethod == 3" style="    width: 100%; overflow-x: auto;">
        <div style="display: flex;">
          <div
            style="display: flex;flex-direction: column;flex:1;align-items: center;justify-content: center;padding: 10px;">
            <mat-label>{{"General Information" | translate | async}}</mat-label>
          </div>
          <div
            style="display: flex;flex-direction: column;flex:1;align-items: center;justify-content: center;padding: 10px;">
            <mat-label>{{'Polynomial Worn Limits' | translate | async}}</mat-label>
          </div>
        </div>

        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>{{'Make' | translate | async}}</th>
              <th>{{'Comp. Type' | translate | async}}</th>
              <th>{{'Component' | translate | async}}</th>
              <th>{{'Part #' | translate | async}}</th>
              <th>{{'Method' | translate | async}}</th>
              <th>{{'Tool Used' | translate | async}}</th>
              <th>{{'Impact 2nd Order' | translate | async}}</th>
              <th>{{'Normal 2nd Order' | translate | async}}</th>
              <th>{{'Impact Slope' | translate | async}}</th>
              <th>{{'Normal Slope' | translate | async}}</th>
              <th>{{'Impact Intercept' | translate | async}}</th>
              <th>{{'Normal Intercept' | translate | async}}</th>
              <th>{{'Starting Dim' | translate | async}}</th>
              <th>{{'100% Worn' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="PolynomialData!=null">
              <tr *ngFor="let item of PolynomialData" (click)="PolynomialRowClick(item)"  style="cursor: pointer;">
                <td class="component-cell">{{MakeName}}</td>
                <td class="component-cell">{{ComprtType}}</td>
                <td class="component-cell">{{Component}}</td>
                <td class="component-cell">{{PartNo}}</td>
                <td class="component-cell">{{MethodName}}</td>
                <td class="component-cell">{{item.ToolName}}</td>
                <td class="component-cell">{{item.impact_secondOrder}}</td>
                <td class="component-cell">{{item.normal_secondOrder}}</td>
                <td class="component-cell">{{item.impact_slope}}</td>
                <td class="component-cell">{{item.normal_slope}}</td>
                <td class="component-cell">{{item.impact_intercept}}</td>
                <td class="component-cell">{{item.normal_intercept}}</td>
                <td class="component-cell">{{item.Starting_Dim}}</td>
                <td class="component-cell">{{item.Worn_100}}</td>
              </tr>
            </ng-container>
            <tr *ngIf="PolynomialData==null">
              {{'No records to display.' | translate | async}}
            </tr>

          </tbody>
        </table>
      </div>


      <!--liebherr -- Or Linear-->
      <div *ngIf="selectedMethod == 5" style="    width: 100%; overflow-x: auto;">
        <div style="display: flex;">
          <div
            style="display: flex;flex-direction: column;flex:1;align-items: center;justify-content: center;padding: 10px;">
            <mat-label>{{'General Information' | translate | async}}</mat-label>
          </div>
          <div
            style="display: flex;flex-direction: column;flex:1;align-items: center;justify-content: center;padding: 10px;">
            <mat-label>{{'Linear Worn Limits' | translate | async}}</mat-label>
          </div>
        </div>

        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>Make</th>
              <th>Comp. Type</th>
              <th>Component</th>
              <th>Part #</th>
              <th>Method</th>
              <th>Tool Used</th>
              <th>Impact Slope</th>
              <th>Normal Slope</th>
              <th>Impact Intercept</th>
              <th>Normal Intercept</th>
              <th>Starting Dim</th>
              <th>100% Worn</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="LinearData!=null">
              <tr *ngFor="let item of LinearData" (click)="LinearRowClick(item)"  style="cursor: pointer;"> 
                <td class="component-cell">{{MakeName}}</td>
                <td class="component-cell">{{ComprtType}}</td>
                <td class="component-cell">{{Component}}</td>
                <td class="component-cell">{{PartNo}}</td>
                <td class="component-cell">{{MethodName}}</td>
                <td class="component-cell">{{item.ToolName}}</td>
                <td class="component-cell">{{item.impact_slope}}</td>
                <td class="component-cell">{{item.normal_slope}}</td>
                <td class="component-cell">{{item.impact_intercept}}</td>
                <td class="component-cell">{{item.normal_intercept}}</td>
                <td class="component-cell">{{item.Starting_Dim}}</td>
                <td class="component-cell">{{item.Worn_100}}</td>


              </tr>
            </ng-container>
            <tr *ngIf="LinearData==null">
              {{'No records to display.' | translate | async}}
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card>

    <mat-card>
      <mat-card-title>{{'Worn Limit Setup' | translate | async}}</mat-card-title>

      <mat-card-content>

        <div class="search-options"
          style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'Method of Calculation' | translate | async}}</mat-placeholder>
            <mat-select id="select-filter" [(ngModel)]="selectedMethod" ngDefaultControl>
              <mat-option [value]="mdl.Id" *ngFor="let mdl of MethodList">
                {{mdl.Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'Tools' | translate | async}}</mat-placeholder>
            <mat-select id="select-tool" [(ngModel)]="selectedTool" ngDefaultControl>
              <mat-option [value]="mdl.Id" *ngFor="let mdl of ToolList">
                {{mdl.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>Model</mat-placeholder>
            <input matInput [disabled]="true" [(ngModel)]="labelModel">
          </mat-form-field> -->

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'Part #' | translate | async}}</mat-placeholder>
            <input matInput [disabled]="true" [(ngModel)]="labelPart">
          </mat-form-field>

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'U/C Make' | translate | async}}</mat-placeholder>
            <input matInput [disabled]="true" [(ngModel)]="labelMake">
          </mat-form-field>


        </div>

        <!--CAT -- Or Inflection-->
        <div *ngIf="selectedMethod == 2" class="search-options" style="display: flex;flex-direction: column;">

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'Adjustment to Base' | translate | async}}</mat-placeholder>
            <input matInput [(ngModel)]="AdjustmentToBase">
          </mat-form-field>

          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>{{'Slope' | translate | async}}</mat-placeholder>
            <input matInput [(ngModel)]="Slope">
          </mat-form-field>

          <div style="display: flex;flex-direction: row;justify-content: space-between;width: 50%">
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'H.I. - Inflection Point' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="HIInflectionPoint" (change)="ChangeHIInflectionPoint()" >
            </mat-form-field>
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'M.I. - Inflection Point' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="MIInflectionPoint">
            </mat-form-field>
          </div>

          <div style="display: flex;flex-direction: row;justify-content: space-between;width: 50%">
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'H.I. - Slope 1' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="HISlope1" (change)="ChangeHISlope1()">
            </mat-form-field>
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'M.I. - Slope 1' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="MISlope1">
            </mat-form-field>
          </div>

          <div style="display: flex;flex-direction: row;justify-content: space-between;width: 50%">
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'H.I. -Y Intercept 1' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="HIYIntercept1" (change)="ChangeHIYIntercept1()">
            </mat-form-field>
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'M.I. -Y Intercept 1' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="MIYIntercept1">
            </mat-form-field>
          </div>

          <div style="display: flex;flex-direction: row;justify-content: space-between;width: 50%">
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'H.I. - Slope 2' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="HISlope2" (change)="ChangeHISlope2()">
            </mat-form-field>
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'M.I. - Slope 2' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="MISlope2">
            </mat-form-field>
          </div>

          <div style="display: flex;flex-direction: row;justify-content: space-between;width: 50%">
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'H.I. -Y Intercept 2' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="HIYIntercept2" (change)="ChangeHIYIntercept2()">
            </mat-form-field>
            <mat-form-field style="width: 15%;" class="header-form-full-width">
              <mat-placeholder>{{'M.I. -Y Intercept 2' | translate | async}}</mat-placeholder>
              <input matInput [(ngModel)]="MIYIntercept2">
            </mat-form-field>
          </div>


          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>0% {{'Worn Dimension' | translate | async}}</mat-placeholder>
            <input matInput [(ngModel)]="startingDim">
          </mat-form-field>
          <mat-form-field style="width: 15%;" class="header-form-full-width">
            <mat-placeholder>100% {{'Worn' | translate | async}}</mat-placeholder>
            <input matInput [(ngModel)]="_100perceDim">
          </mat-form-field>




        </div>

        <!--itm -- Or Stepped-->
        <div *ngIf="selectedMethod == 1" class="search-options">
          <div style="display: flex;flex-direction: row;flex: 1;width: '60%';min-width: '60%';">
            <div style="display: flex;flex-direction: column;margin-right: 10%;">
              <mat-label>{{'Impact' | translate | async}}</mat-label>
              <mat-form-field style="width: 45%;" class="header-form-full-width">
                <mat-placeholder>{{'Start Depth.New' | translate | async}} (mm)</mat-placeholder>
                <input type="number" matInput [(ngModel)]="ImpactStartDepthNew" tabindex="1"
                (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
              </mat-form-field>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>10% {{"Wear Depth" | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact10WearDepth" tabindex="2"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>70% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact70WearDepth"  tabindex="9"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>20% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact20WearDepth" tabindex="3"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>80% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact80WearDepth" tabindex="10"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>30% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact30WearDepth" tabindex="4"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>90% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact90WearDepth" tabindex="11"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>40% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact40WearDepth" tabindex="5"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>100% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact100WearDepth" tabindex="12"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>50% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact50WearDepth" tabindex="6"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>110% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact110WearDepth" tabindex="13"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>60% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input matInput type="number" [(ngModel)]="Impact60WearDepth" tabindex="7"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>120% {{'Wear Depth' | translate | async }} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Impact120WearDepth" tabindex="14"
                  (ngModelChange)="copyValueTolimitWorn()" (keypress)="ValidateNumberInputs($event)">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
              <mat-form-field style="width: 45%;" class="header-form-full-width">
                <mat-placeholder>0% {{'Worn Dimension' | translate | async }}</mat-placeholder>
                <input matInput [(ngModel)]="startingDim" tabindex="8">
              </mat-form-field>
              <mat-form-field style="width: 45%;" class="header-form-full-width">
                <mat-placeholder>100% {{'Worn' | translate | async}}</mat-placeholder>
                <input matInput [(ngModel)]="_100perceDim" tabindex="15">
              </mat-form-field>
              </div>

            </div>
            <div style="display: flex;flex-direction: column;">
              <mat-label>{{'Normal' | translate | async}}</mat-label>
              <mat-form-field style="width: 45%;" class="header-form-full-width">
                <mat-placeholder>{{'Start Depth.New' | translate | async}} (mm)</mat-placeholder>
                <input type="number" matInput [(ngModel)]="NormalStartDepthNew" tabindex="16">
              </mat-form-field>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>10% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal10WearDepth" tabindex="17">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>70% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal70WearDepth" tabindex="23">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>20% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal20WearDepth" tabindex="18">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>80% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal80WearDepth" tabindex="24">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>30% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal30WearDepth" tabindex="19">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>90% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal90WearDepth" tabindex="25">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>40% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal40WearDepth" tabindex="20">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>100% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal100WearDepth" tabindex="26">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>50% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal50WearDepth" tabindex="21">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>110% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal110WearDepth" tabindex="27">
                </mat-form-field>
              </div>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>60% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input matInput type="number" [(ngModel)]="Normal60WearDepth" tabindex="22">
                </mat-form-field>
                <mat-form-field style="width: 45%;" class="header-form-full-width">
                  <mat-placeholder>120% {{'Wear Depth' | translate | async}} (mm)</mat-placeholder>
                  <input type="number" matInput [(ngModel)]="Normal120WearDepth" tabindex="28">
                </mat-form-field>
              </div>


              
            </div>

          </div>

          
        </div>

        <!--komatsu -- Or Ploynomial-->
        <div *ngIf="selectedMethod == 3" class="search-options">
          <div style="display: flex;flex-direction: row;flex: 1;width: '100%';min-width: '60%';">
            <div style="display: flex;flex-direction: column;margin-right: 10%;">
              <mat-label>{{'Slope Direction - Impact' | translate | async}}</mat-label>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Impact 2nd Order' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialImpact2ndOrder">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Impact Slope' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialImpactSlope">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Impact Intercept' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialImpactIntercept">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>0% {{'Worn Dimension' | translate | async}}</mat-placeholder>
                <input matInput [(ngModel)]="startingDim">
              </mat-form-field>

            </div>
            <div style="display: flex;flex-direction: column;">

              <mat-label>{{'Slope Direction - Normal' | translate | async}}</mat-label>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Normal 2nd Order' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialNormal2ndOrder">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Normal Slope' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialNormalSlope">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Normal Intercept' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="PolynomialNormalIntercept">
              </mat-form-field>
              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>100% {{'Worn' | translate | async}}</mat-placeholder>
                <input matInput [(ngModel)]="_100perceDim">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!--liebherr -- Or Linear-->
        <div *ngIf="selectedMethod == 5" class="search-options">
          <div style="display: flex;flex-direction: row;flex: 1;width: '60%';min-width: '60%';">
            <div style="display: flex;flex-direction: column;margin-right: 10%;">
              <mat-label>{{'Slope Direction - Impact' | translate | async}}</mat-label>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Impact Slope' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="LinearImpactSlope">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Impact Intercept' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="LinearImpactIntercept">
              </mat-form-field>
              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>0% {{'Worn Dimension' | translate | async}}</mat-placeholder>
                <input matInput [(ngModel)]="startingDim">
              </mat-form-field>
            </div>
            <div style="display: flex;flex-direction: column;">

              <mat-label>{{'Slope Direction - Normal' | translate | async}}</mat-label>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Normal Slope' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="LinearNormalSlope">
              </mat-form-field>

              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>{{'Normal Intercept' | translate | async}}</mat-placeholder>
                <input type="number" matInput [(ngModel)]="LinearNormalIntercept">
              </mat-form-field>
              <mat-form-field style="width: 100%;" class="header-form-full-width">
                <mat-placeholder>100% {{'Worn' | translate | async}}</mat-placeholder>
                <input matInput [(ngModel)]="_100perceDim">
              </mat-form-field>

            </div>
           

          </div>
         
          
        </div>

      </mat-card-content>

      <mat-card-actions style="display: flex;
      justify-content: flex-end;">
        <button mat-raised-button color="warn" (click)="AddWornLimits()" style="margin-right: 20px;"> {{'Add New Limit' | translate | async}}
        </button>
        <button mat-raised-button color="warn" (click)="UpdateWornLimits()" style="margin-right: 20px;"> {{'Update' | translate | async}} </button>

      </mat-card-actions>


    </mat-card>



  </mat-card-content>


</mat-card>